import { optimizedProductFieldsString } from './fragmentOptimizedProductFields';

export default `
  #graphql
  fragment OptimizedProductFieldsWithoutCategories on ProductInterface {
    ${optimizedProductFieldsString}
  }
`;
